export default __webpack_public_path__ + "static/media/warranty-portal.8322300b.webp";